<template>
    <v-app>
        <template v-if="mentionPageReady">
            <v-layout row wrap>
                <v-flex v-if="!monitor.processed && alertMsg" sm12 md12 xs12>
                    <v-alert
                            dismissible
                            type="warning"
                            :value="!monitor.processed"
                            @input="alertMsg = false"
                    >
                        <span class="subheading font-weight-bold">This monitor is under processing</span>
                    </v-alert>
                </v-flex>
                <v-flex d-flex md8 sm6 xs12>
                    <Keywords
                            :name="monitor.name"
                            :mentionPageReady="mentionPageReady"
                            :keywords="keywords"
                            :created-at="monitor.created_at"
                    />
                </v-flex>
                <v-flex d-flex md4 sm6 xs12>
                    <FacebookInfo/>
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex md12>
                    <TotalMentionGraph
                        :summaryData="totalMention"
                        :summaryDataReady="childComponentReady"
                    />
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs12>
                    <FacebookTopMentionGraph
                        :summaryDataReady="childComponentReady"
                    />
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 md8>
                    <AppChartWrapper imageName="Engagement Over time">
                        <h4 slot="title" class="subheading text-xs-left font-weight-regular section-title--color">
                            Engagement Over Time
                        </h4>
                        <template slot="chart">
                            <LineChart
                                    v-if="summaryReady"
                                    :chartData="engagementChartData"
                                    :height="340"
                                    :options="engagementChartOptions"
                                    :width="500"
                            />
                        </template>
                    </AppChartWrapper>
                </v-flex>
                <v-flex xs12 md4>
                    <AppChartWrapper
                        imageName="Engagement"
                        style="height:100%;"
                    >
                        <h4 slot="title" class="subheading text-xs-left font-weight-regular section-title--color">
                            Total Engagement - {{totalEngagement | formatNumber}}
                        </h4>
                        <template v-if="summaryReady" v-slot:chart>
                            <PieChart
                                    :chartData="engagementPieChartData"
                                    :height="230"
                                    :options="engagementPieChartOptions"
                                    :width="230"
                            />
                            <v-layout justify-space-around mt-4 mx-1 row text-sm-center text-xs-center wrap>
                                <v-flex :key="stat[0]" md3 v-for="stat in engagementMetric">
                                    <h4 class="font-weight-bold title" style="color: #3c5897;">{{ stat[1] |
                                        abbrNumber }}</h4>
                                    <span class="section__title--color font-weight-bold body-1 text-capitalize">{{stat[0]}}</span>
                                </v-flex>
                            </v-layout>
                        </template>
                    </AppChartWrapper>
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex md12>
                    <PostReactionGraph
                            :summaryReady="summaryReady"
                            :summaryData="facebookSummary"
                    />
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex d-flex xs12 sm12 md8 lg8>
                    <ReactionCloud />
                </v-flex>
                <v-flex d-flex xs12 sm12 md4 lg4>
                    <TotalCategoriesGraph
                            :categoryColor="reactionCategoryColor"
                            :categoryRangeOrdered="reactionDataRangeOrdered"
                            :summaryDataReady="true"
                            :isReaction="true"
                            name="Total Reaction"
                    ></TotalCategoriesGraph>
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex md8 sm6 xs12>
                    <AppChartWrapper
                        imageName="Total Mentions by Keyword"
                    >
                        <h4 slot="title" class="subheading text-xs-left font-weight-regular section-title--color">Total Mentions by Keyword</h4>
                        <BarChart
                                slot="chart"
                                class="pt-3"
                                v-if="summaryReady"
                                :chartData="totalMentionByKeywordChartData"
                                :options="totalMentionByKeywordChartOptions"
                                :height="300"
                                :width="900"
                        />
                    </AppChartWrapper>
                </v-flex>
                <v-flex md4 sm6 xs12>
                    <KeywordsFilter
                            :keywordsFilter="keywordsFilter"
                            @postFilter="postFilter"
                    />
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex d-flex md8 sm6 xs12>
                    <v-card width="100%" flat>
                        <v-toolbar flat color="#fff">
                            <v-text-field
                                    :value="postListSearchTerm"
                                    @change="value => postListSearchTerm = value"
                                    @keyup.enter="postFilter"
                                    clearable
                                    @click:clear="clearSearchTerm"
                                    background-color="#f4f4f4"
                                    class="pt-2 search-box--height"
                                    flat
                                    height="41"
                                    placeholder="Search Here"
                                    solo
                            />
                            <v-btn
                                    :class="{'pointer-wait':!postReady}"
                                    :ripple="false"
                                    @click="postFilter"
                                    color="bindezcolor"
                                    dark
                                    depressed
                                    small
                            >
                                <span class="font-weight-regular text-capitalize" style="font-size: 14px;">Search</span>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn @click="toggleManyPost" :disabled="!selectedPosts.length > 0" icon :ripple="false" flat>
                                <span v-show="!sameStatus"><v-icon>remove_red_eye</v-icon></span>
                                <span v-show="sameStatus"><v-icon small>fas fa-eye-slash</v-icon></span>
                            </v-btn>
                            <v-divider class="mx-2" vertical inset></v-divider>
                            <v-btn disabled icon :ripple="false" flat>
                                <v-icon>restore_from_trash</v-icon>
                            </v-btn>
                            <v-divider class="mx-2" vertical inset></v-divider>
                            <v-btn disabled icon :ripple="false" flat>
                                <v-icon>local_offer</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <template v-if="mentionPageReady && postReady">
                            <v-list>
                                    <div v-for="post in monitorFacebookPosts" :key="post.id" class="px-2 py-3 list__item-bottom-seperator">
                                        <v-list-tile avatar>
                                            <v-list-tile-action>
                                                <v-checkbox
                                                        class="custom-checkbox-size"
                                                        hide-details
                                                        :value="post.id"
                                                        v-model="selectedPosts"
                                                        :ripple="false"
                                                        color="bindezcolor">
                                                </v-checkbox>
                                            </v-list-tile-action>
                                            <v-list-tile-avatar size="50" class="mr-2">
                                                <v-img @error="avatarImageErrorHandler" v-if="post.from" :src="avatarImage(`//graph.facebook.com/${post.from.id}/picture?width=50`)"></v-img>
<!--                                                <img v-if="post.from" :src="'//graph.facebook.com/'+post.from.id+'/picture?width=50'">-->
                                            </v-list-tile-avatar>
                                            <v-list-tile-content>
                                                <v-list-tile-title>
                                                    <a
                                                            v-if="post.from"
                                                            @click="toPostDetail(post.id)"
                                                            style="text-decoration: none; color:#000"
                                                            class="zawgyi body-1 font-weight-medium text-truncate">
                                                        {{post.from.name | fromUnicodeToZawgyi }}
                                                    </a>
                                                    <span v-else class="body-1 font-weight-medium text-truncate">Post Name</span>
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                    <span class="caption fb-media-des--color font-italic">{{post.created_time | monitorPostFilter }} by</span>
                                                    <a
                                                            v-if="post.from"
                                                            :href="'https://www.facebook.com/'+post.from.id"
                                                            class="caption font-weight-bold zawgyi"
                                                            style="text-decoration: none; color:#afbac8;"
                                                            target="_blank">
                                                        {{post.from.name}}
                                                    </a>
                                                    <span class="caption font-weight-bold" v-else>Post Name</span>
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                            <v-flex xs2>
                                                <v-switch
                                                        color="bindezcolor"
                                                        v-model="post.relevant"
                                                        @change="toggleWatch(post.relevant, post.id)"
                                                        class="pt-0 mt-0"
                                                        hide-details
                                                        :readonly="selectedPosts.length > 0"
                                                >
                                                    <template slot="label">
                                                                <span :class="{ 'watch' : post.relevant}"
                                                                      class="font-weight-bold caption">{{ post.relevant ? 'Watched' : 'Unwatched'}}</span>
                                                    </template>
                                                </v-switch>
                                            </v-flex>
                                        </v-list-tile>
                                        <v-layout row>
                                            <v-flex xs10 offset-xs1 sm12 offset-sm1 pl-0 style="padding-right: 25px;">
                                                <p
                                                        class="zawgyi caption mb-0"
                                                        :inner-html.prop="(post.message || post.description) | highlightPost(keywordsHighlight) | excerpt(200) | fromUnicodeToZawgyi"
                                                        style="max-height:100px; overflow:hidden; line-height: 20px; word-break:break-word">
                                                </p>
                                                <v-layout row align-center justify-space-between>
                                                    <v-flex xs4>
                                                        <span class="caption mr-1">
                                                             <v-icon class="icon-size" color="#929bae">fas fa-thumbs-up</v-icon>
                                                             <span class="post-reaction--customize">{{post.likes && post.likes.summary.total_count | abbrNumber}}</span>
                                                        </span>
                                                        <span class="caption mr-1">
                                                             <v-icon class="icon-size" color="#929bae">fas fa-comments</v-icon>
                                                             <span class="post-reaction--customize">{{post.comments && post.comments.summary.total_count | abbrNumber}}</span>
                                                         </span>
                                                        <span class="caption">
                                                            <v-icon class="icon-size" color="#929bae">fas fa-share</v-icon>
                                                            <span class="post-reaction--customize">{{post.shares !== undefined ? post.shares.count : 0 | abbrNumber}}</span>
                                                        </span>
                                                    </v-flex>
                                                    <v-flex xs8 text-xs-right>
                                                        <v-chip
                                                                disabled
                                                                class="px-0"
                                                                v-for="(sentiment, index) in post.sentiment_summary"
                                                                small
                                                                outline
                                                                label
																:key="index"
                                                                :color="sentiment.category"
                                                                v-show="post.relevant"
                                                        >
                                                            <v-icon :color="sentiment.category" small class="mr-1">
                                                                far fa-comments
                                                            </v-icon>
                                                            <span
                                                                    style="font-size:10px;"
                                                                    class="font-weight-bold">
                                                                {{sentiment.count | abbrNumber}}
                                                            </span>
                                                        </v-chip>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                            </v-list>
                            <div v-if="monitorFacebookPosts.length === 0"
                                 class="text-xs-center d-flex fill-height align-center">
                                <span class="font-weight-bold display-1" style="color:#AFBAC8">No Post Found</span>
                            </div>

                        </template>
                        <div v-else class="text-xs-center align-center d-flex fill-height">
                            <v-progress-circular
                                    indeterminate
                                    color="bindezcolor"
                            />
                        </div>
                        <div v-if=" postReady && (monitorFacebookPosts.length > 0)"
                             class="text-xs-center py-2 mt-2">
                            <AppBindezPagination
                                    :disabled="!monitorActionReady"
                                    :length="pageLength"
                                    v-model="page"
                                    circle
                                    @input="paginate"
                                    :next-skip-count="skipCount"
                                    color="bindezcolor"
                                    total-visible="8"
                            >
                            </AppBindezPagination>
                        </div>
                    </v-card>
                </v-flex>
                <v-flex md4 sm6 xs12>
                    <v-layout row wrap>
                        <v-flex md12>
                            <FacebookTopMention name="Facebook Top Mentions" v-model="topMention" :ready="mentionPageReady && summaryReady" v-bind="{facebookTopMention}" @filter="postFilter()"></FacebookTopMention>
                        </v-flex>
                        <v-flex md12>
                            <PostFilter @postFilter="postFilter"></PostFilter>
                        </v-flex>
                        <v-flex d-flex xl12 md12 sm12 xs12>
                            <PostSortable @postFilter="postFilter()"></PostSortable>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </template>
        <div class="text-xs-center" v-else>
            <Spinner/>
            <span class="font-weight-bold display-1 description--color">Loading...</span>
        </div>
    </v-app>
</template>

<script>
	/*eslint-disable*/
	import rabbit from 'rabbit-node'
	import BarChart from '@/components/BarChart.vue'
	import LineChart from '@/components/LineChart.vue'
	import PieChart from '@/components/PieChart.vue'
	import FacebookInfo from '@/components/Mention/FacebookInfo'
	import Keywords from '@/components/Mention/Keywords'
	import KeywordsFilter from '@/components/Mention/KeywordsFilter'
    import AppBindezPagination from '@/components/AppBindezPagination'
	import moment from 'moment'
	import {mapActions, mapState, mapGetters, mapMutations} from 'vuex'
	import Spinner from '@/components/Spinner'
	import {thousandSeperator, abbrNum, formatKeyword} from '@/utils'
	import PostSortable from "../components/Mention/PostSortable";
	import FacebookTopMention from "../components/Mention/FacebookTopMention";
	import knayi from 'knayi-myscript';
	import TotalMentionGraph from "../components/Mention/TotalMentionGraph";
	import PostReactionGraph from '@/components/Mention/PostReactionGraph';
	import ReactionCloud from "@/components/Mention/ReactionCloud";
    import TotalCategoriesGraph from '@/components/TotalCategoriesGraph';
	import authCurrentUser from "../mixins/authCurrentUser";
	import PostFilter from '@/components/Mention/PostFilter';
	import FacebookTopMentionGraph from "../components/Mention/FacebookTopMentionGraph";
	import downloadChart from "@/mixins/downloadChart";
	import _truncate from 'lodash/truncate';
    import AppChartWrapper from "../components/AppChartWrapper";
    import imageFallback from "../mixins/imageFallback";

	export default {
		name: "Mention",
		props: {
			monitor_uuid: {
				required: true,
				type: String
			}
		},
        mixins:[authCurrentUser, downloadChart, imageFallback],
		data() {
			return {
				watcher: undefined,
                skipCount: 5,
				monitorFacebookPostsReady: false,
				skip: 0,
				alertMsg: true,
				active: "null",
				tags: '',
				selectedPosts: [],
				engagementPieChartOptions: {
					responsive: true,
					maintainAspectRatio: false,
					legend: {
						labels: {
							boxWidth: 14,
							fontSize: 10
						}
					},
                    tooltips:{
						callbacks:{
							label(item, dataset){
								return thousandSeperator(dataset.datasets[item.datasetIndex].data[item.index]);
                            }
                        }
                    }
				},

				engagementChartOptions: {
					responsive: true,
					maintainAspectRatio: false,
					layout: {
						padding: {
							right: 10,
							left: 8,
							bottom: 24
						}
					},
					tooltips: {
						mode: 'index',
						intersect: false,
                        callbacks:{
							label(item, data){
								return thousandSeperator(item.value);
                            }
                        }
					},
					scales: {
						xAxes: [
							{
								gridLines: {
									display: false
								},
								ticks: {
									barThickness: 3
								}
							}
						],
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									padding: 18,
                                    callback(value, index, values){
										return abbrNum(value,2);
                                    }
								}
							}
						]
					}
				},

				totalMentionByKeywordChartOptions: {
					responsive: true,
					maintainAspectRatio: false,
					layout: {
						padding: {
							top: 10,
							left: 10,
							right: 10,
							bottom: 10
						}
					},
					legend: {
						display: false
					},
					tooltips: {
						mode: 'index',
						intersect: false,
						callbacks:{
							title(item){
								let label = this._data.labels[item[0].index];
								let isZawgyi = (knayi.fontDetect(label) === 'zawgyi');
								return isZawgyi ? label : rabbit.uni2zg(label);
							},
							label(item, data){
								return thousandSeperator(item.value);
							}
						},
                        titleFontFamily: "Zawgyi-One"
					},
					scales: {
						xAxes: [
							{
								gridLines: {
									display: false
								},
								barThickness: 20,
								ticks: {
									fontFamily: 'Zawgyi-One',
									maxRotation: 30,
									fontSize: 12,
                                    callback(label){
										return _truncate(label,{length: 18})
                                    }
								}
							}
						],
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									barThickness: 3,
									padding: 18,
                                    callback(value, index, values){
										return abbrNum(value,2);
                                    }
								},
							}
						]
					}
				},

				reactionCategories: ['like', 'love', 'haha', 'sad', 'wow', 'angry'],

				reactionCategoryColor: {
					like: '#558DFD',
					love: '#FF009D',
					haha: '#F9C02F',
					sad: '#32C5FF',
					wow: '#000000',
					angry: '#FF0100',
				}
			}
		},
		computed: {
			...mapState('mention', [
				'status',
				'postReady',
				'sortByType',
				'currentPage',
				'sortByOrder',
				'summaryReady',
				'monitorFanCount',
				'mentionPageReady',
				'selectedKeywords',
				'selectedFbTopMention',
                'searchTerm',
			]),

			...mapState([
				'monitor',
				'selectedDate',
				'facebookSummary',
                'monitorActionReady',
                'engagementStats'
			]),

			...mapGetters('mention', [
				'monitorFacebookPosts',
				'monitorFacebookPostCount',
                'getTotalMention',
                "facebookTopMention",
			]),

			page: {
				get() {
					return this.currentPage
				},
				set(value) {
					this.setCurrentPage(value);
				}
			},

            keywordsHighlight(){
				return this.keywordsFilter.map(keyword => keyword[0]);
            },

			keywordsFilter() {
                let {facebook_mentions_by_keywords : data} = this.facebookSummary;
				return Object.keys(data)
                    .map((k) => [k, data[k]]).sort((cur, pre) => pre[1] - cur[1])
                    .filter(keyword => keyword[1] > 0);
			},

            keywordsFilterLimit(){
			    return this.selectedKeywords.length >= 1 ? this.keywordsFilter : this.keywordsFilter.slice(0, 10);
            },

			totalMentionByKeywordChartData() {
				let labels = [];
				let data = [];
				if (this.selectedKeywords.length > 0) {
					this.keywordsFilterLimit.filter(item => {
						return this.selectedKeywords.includes(item[0])
					}).map(item => {
						labels.push(rabbit.uni2zg(item[0]));
						data.push(item[1]);
					})
				} else {
					this.keywordsFilterLimit.map(item => {
						labels.push(rabbit.uni2zg(item[0]));
						data.push(item[1]);
					});
				}
				labels = labels.map(label => formatKeyword(label));
				return {
					labels,
					datasets: [
						{
							label: "Keywords",
							backgroundColor: "#009fd6",
							data
						}
					]
				}
			},

			pageLength() {
				return Math.ceil(this.monitorFacebookPostCount / 10)
			},

            totalMention(){
			    return [
                    {
                    	range: this.facebookSummary.fbposts.range_count,
                        label: "Facebook",
	                    backgroundColor: "rgba(31, 101, 197, 0.1)",
	                    borderColor: "#1F65C5",
	                    fill: true
                    }
                ]
            },

			engagementChartData() {
				let colormaps = {
					'reactions': {
						borderColor: "#14B277",
						backgroundColor: "rgba(20, 178, 119, 0.1)"

					},
					'comments': {
						borderColor: "#38599A",
						backgroundColor: "rgba(56, 89, 154, 0.1)"
					},
					'shares': {
						borderColor: "#F6A81E",
						backgroundColor: "rgba(246, 168, 30, 0.1)"
					}

				};
				let interactions = this.facebookSummary.interactions;
				let datasets = ['reactions', 'comments', 'shares'].map((t) => {
					return {
						label: t,
						data: interactions.map((i) => i[t] || 0),
						borderColor: colormaps[t].borderColor,
						backgroundColor: colormaps[t].backgroundColor
					}
				});
				return {
					labels: interactions.map((i) => moment(i.val).format("YYYY-MM-DD")),
					datasets
				}
			},

            orderedEngagementStats(){
				return ["reactions", "comments", "shares"].map(item => {
					let stats = `total_${item}`;
					return {[item]: this.engagementStats[stats]};
                });
            },

            engagementMetric(){
				return this.orderedEngagementStats.map(stat => [Object.keys(stat)[0], Object.values(stat)[0]]);
            },

			engagementPieChartData() {
				return {
					datasets: [{
						data: this.orderedEngagementStats.map(stat => Object.values(stat)[0]),
						backgroundColor: ["#14B277", "#38599A", "#F6A81E"]
					}],
					labels: this.orderedEngagementStats.map(stat => Object.keys(stat)[0])
				}
			},

			totalEngagement() {
				return this.orderedEngagementStats
					.map(status => Object.values(status)[0])
					.reduce((acc, cur) => acc + cur, 0)
			},

			totalFacebookPages() {
				let pages = this.facebookSummary.fbposts.page_id;
				return pages.length / 2;
			},

			keywords() {
				return this.monitor.keywords.map(keyword => {
					return {
						name: rabbit.uni2zg(keyword),
						color: "#4FAF79",
						icon: "close",
						available: true
					}
				});
			},

			totalCmtsMetric() {
				return this.engagementStats.total_comments;
			},

			postsForToggle() {
				return this.monitorFacebookPosts.filter(post => this.selectedPosts.includes(post.id))
			},

			sameStatus() {
				let isAllSelectedPostsRelevant = this.postsForToggle.every(post => post.relevant);
				return this.postsForToggle.length > 0 ? isAllSelectedPostsRelevant : false;
			},

            reactionDataRangeOrdered(){
			    let reactions = this.facebookSummary.reactions || {};
			    let count  = reactions.count || {};
			    return ['like', 'love', 'haha', 'sad', 'wow', 'angry'].map(item => {
			    	return {
			    		count: count[`total_${item}`],
                        field: "category",
                        value: item,
                        img: require(`@/assets/reactions/${item[0].toUpperCase()+item.slice(1)}.svg`)
                    }
                })
            },

            childComponentReady(){
				return this.mentionPageReady && this.summaryReady;
            },

			postListSearchTerm: {
				get() {
					return this.searchTerm;
				},
				set(term) {
					this.setSearchTerm(term);
				}
			},

			topMention:{
				get(){
					return this.selectedFbTopMention;
				},
                set(page){
                    return this.setSelectedFbTopMention(page);
                }
            }
		},

		methods: {
			...mapActions('mention', [
				'fetchMonitorFanCount',
				'fetchMonitorFacebookPosts',
				'updatePostStatus',
			]),


			...mapActions([
				'fetchMonitor',
				'fetchFacebookSummary',
                'fetchEngagementStats'
			]),

			...mapMutations('mention', [
				'setMonitorFanCount',
				'setMonitorFacebookPosts',
				'setMentionPageReady',
                'setPostReady',
                'setCurrentPage',
                'setDefaultMentionState',
                'setSearchTerm',
                "setSelectedFbTopMention"
			]),

			...mapMutations([
				'setMonitor',
                'setMonitorActionReady',
                'setEngagementReady'
			]),

            ...mapMutations('monitors',[
            	'setReady'
            ]),

            toPostDetail(postId){
	            let postRoute = this.$router.resolve({
		            name: "postdetail",
		            params: {post_id: postId, monitor_uuid: this.monitor_uuid}
	            });
	            window.open(postRoute.href, '_blank');
            },

            postFilter(){
			    this.skip = 0;
			    this.page = 1;
			    this.fetchPosts();
            },

            paginate(){
	            this.monitorFacebookPostsReady = false;
	            this.skip = this.page === 1 ? 0 : 10 * (this.page - 1);
	            this.$ua.trackEvent("Paginate Posts", "click");
	            this.fetchPosts();
            },

			fetchPosts() {
				this.selectedPosts = [];
                this.setPostReady(false);
                this.setMonitorActionReady(false);
                let term = knayi.fontDetect(this.postListSearchTerm) !== 'zawgyi' ? this.postListSearchTerm : rabbit.zg2uni(this.postListSearchTerm);
				this.fetchMonitorFacebookPosts({
					monitor_uuid: this.monitor_uuid,
					timerange: this.selectedDate,
                    sort: {type: this.sortByType, order: this.sortByOrder},
                    watched: this.status,
					keywords: this.selectedKeywords.join(),
                    pages: this.selectedFbTopMention,
					skip: this.skip,
                    term
				})
					.then(() => {
						this.setPostReady(true);
						this.setMonitorActionReady(true);
					});
			},

            clearSearchTerm(){
				this.postListSearchTerm = null;
				this.page = 1;
				this.fetchPosts();
            },

			toggleWatch(relevant = undefined, id = undefined) {
				this.setMonitorActionReady(false);
				this.updatePostStatus({
					post_id: id,
					monitor_uuid: this.monitor_uuid,
					relevant: relevant
				}).then(data => {
					this.setMonitorActionReady(true);
					this.$ua.trackEvent("Update Post Status", "click", `${this.authenticatedUser.email || 'User'} update ${this.monitor_uuid || 'Monitor'}'s single post's status(${relevant}`);
				}).finally(_ => this.setMonitorActionReady(true));
			},

            toggleManyPost(){
	            this.setMonitorActionReady(false);
	            let allRelevant = this.postsForToggle.every(post => post.relevant);
	            let data = this.postsForToggle.map(fpost => ({
		            monitor_uuid: this.monitor_uuid,
		            post_id: fpost.id,
		            relevant: !allRelevant//if all posts relevant are true, must be toggle to false otherwise true
	            }));
	            this.updatePostStatus(data)
		            .then(data => {
			            this.setMonitorActionReady(true);
			            this.postsForToggle.forEach(post => post.relevant = !allRelevant);//update UI after full-filled.
			            this.$ua.trackEvent("Update Post Status", "click", `${this.authenticatedUser.email || 'User'} update ${this.monitor_uuid} multiple ${this.postsForToggle.length} posts status(${!allRelevant})`);
		            }).finally(_ => this.setMonitorActionReady(true));
            }

		},

		components: {
			PostFilter,
			TotalMentionGraph,
			FacebookTopMention,
			PostSortable,
			AppBindezPagination,
			FacebookInfo,
			Keywords,
			KeywordsFilter,
			BarChart,
			LineChart,
			PieChart,
			Spinner,
			PostReactionGraph,
			ReactionCloud,
            TotalCategoriesGraph,
			FacebookTopMentionGraph,
            AppChartWrapper
		},

		filters: {
			monitorPostFilter(raw) {
				return moment(raw).format('h:mm a D MMMM, YYYY')
			},

			excerpt(text, padding) {
				if(!text) return;
				const location = text.search("<strong style='color:var(--bindez-green-color);'>");
				const f = Math.max(0, location - (padding + 1));
				const t = Math.min(text.length, location + (padding + 1));
				return text.substring(f, t);
			},
		},

		created() {
			let posts = this.monitorFacebookPosts;
			let testPost;
			if (posts !== undefined) {
				testPost = posts[0]
			}
			if ((this.monitor_uuid !== this.monitor.monitor_uuid)
				|| (testPost === undefined
					|| testPost.monitor_uuid !== this.monitor.monitor_uuid) ) {
				// this.setMonitor({data:{}});
                this.setDefaultMentionState();
				this.setMentionPageReady(false);
				// this.setReady(false);
                this.setEngagementReady(false);
				Promise.all([
					// this.fetchMonitorFanCount({monitor_uuid: this.monitor_uuid}),
					// this.fetchMonitor({monitor_uuid:this.monitor_uuid}),
					this.fetchMonitorFacebookPosts({monitor_uuid: this.monitor_uuid, timerange: this.selectedDate}),
                    this.fetchEngagementStats({monitor_uuid: this.monitor_uuid, timerange: this.selectedDate}),
				]).then(() => {
					this.monitorFacebookPostsReady = true;
					this.setMentionPageReady(true);
					// this.setReady(true);
					this.setEngagementReady(true);
				})
			}
		}
	}
</script>

<style scoped>
    .fb-media-des--color {
        color: #505050;
    }

    .section__title--color {
        color: #BABABA;
    }

    .add-cursor {
        cursor: pointer;
    }

    div.v-radio > div.v-input--selection-controls__input {
        margin-right: 0;
    }

    .add-border {
        border: 2px solid green;
    }

    .pie-chart-wrapper {
        width: 80%;
        height: 75%;
        margin: auto;
        display: flex;
    }

    .pie-chart-wrapper > div:first-child {
        margin: auto;
    }

    .barchart-container {
        width: 46vw;
        position: relative;
    }

    .chart-wrapper > div:first-child {
        margin-left: -14px;
    }

    .v-list__tile > .v-list__tile__action {
        min-width: 30px;
    }

    .post-reaction--customize{
        font-size: 12px;
        display:inline-block;
        margin-left: 4px;
        color: #929bae;
    }

    i.icon-size{
        font-size: 12px;
    }

    .v-btn.v-btn--small,
    .v-btn.v-btn--large {
        height: 41px;
    }

</style>
